'use client';

import {usePathname} from '@components/@nav';
import {useUpdateEffect} from '@hooks';
import {useCrumbsStore, withCrumbsStore} from '@utils/useCrumbsStore';
import {useSearchParams} from 'next/navigation';
import {FC, PropsWithChildren, useLayoutEffect} from 'react';
import {getNewCrumbs} from './getNewCrumbs';
import {getPathWithoutSearch} from './getPathWithoutSearch';

export const CrumbsProvider: FC<PropsWithChildren> = withCrumbsStore(
    ({children}) => {
        const search = useSearchParams().toString();
        const path = usePathname();
        const url = path + (search ? '?' + search : '');

        const crumbs = useCrumbsStore(state => state.crumbs);
        const setCrumbs = useCrumbsStore(state => state.setCrumbs);

        useLayoutEffect(() => {
            if (crumbs) {
                return;
            }
            setCrumbs(getNewCrumbs(url));
        }, []);

        useUpdateEffect(() => {
            const newCrumbs = getNewCrumbs(url);
            let diffIdx = -1;

            for (let i = 0; i < newCrumbs.length; i++) {
                if (
                    getPathWithoutSearch(newCrumbs[i]) !==
                        getPathWithoutSearch(crumbs[i]) ||
                    i === newCrumbs.length - 1
                ) {
                    diffIdx = i;
                    break;
                }
            }

            setCrumbs(
                [
                    ...crumbs.slice(0, diffIdx),
                    ...newCrumbs.slice(diffIdx),
                ].slice(0, newCrumbs.length),
            );
        }, [url]);

        return <>{children}</>;
    },
);
